import './btn-default.css';


function BtnDefault() {
    return(
        <>
            <button type="button" className='btn-default'>Saiba mais</button>
        </>
    );
}

export default BtnDefault;